import styled from "styled-components";

export const RadioButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 6px;
    align-items: flex-start;
    width: 100%;
    white-space: nowrap;
    padding: 6px 0;
`;

export const Root = styled.div`
    display: flex;
    column-gap: 40px;
    row-gap: 15px;
    flex-wrap: wrap;
`;

export const OptionLabel = styled.label`
    cursor: pointer;
    display: flex;
    align-items: center;

    &::before {
        content: "";
        display: inline-block;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        background: transparent;
        border: 1px solid ${({ theme }) => theme.colors.borderLightGray};
        box-sizing: border-box;
        margin-right: 10px;
    }
`;

export const StyledRadio = styled.input`
    background: transparent;
    position: relative;
    visibility: hidden;
    margin: 0;
    padding: 0;
    display: none;

    &:checked + ${OptionLabel} {
        &:before,
        &:hover:before {
            border: 5px solid ${({ theme }) => theme.colors.porscheBankBlue};
        }
    }
`;
